import { createContext, useContext } from 'react';

export const LayoutContext = createContext();
export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error(
      'LayoutContext compound components cannot be rendered outside the LayoutContext component',
    );
  }
  return context;
};
